import React from 'react';
import { Fragment } from 'react';
import { SubscriptionShape } from '../shapes';
import SubscriptionOptions from './subscription/subscription_options';
import PropTypes from 'prop-types';

export default class Plans extends React.Component {
  static propTypes = {
    subscription: SubscriptionShape,
    params: PropTypes.object
  }

  render() {
    const headerText = (this.props.subscription.get('active')) ? this.renderUnlimitedText() : this.renderFreeForOneText();
    return (
      <Fragment>
        <div className='row'>
          <p className='col-sm-12'>
            { headerText }
          </p>
        </div>
        <SubscriptionOptions hasActiveSubscription={ this.props.subscription.get('active') } />
      </Fragment>
    );
  }

  renderFreeForOneText() {
    return (
      <Fragment>
        You're on the Free for One plan, which is what everyone starts on. Go <b>Unlimited</b>, unlock the queue, and remember more words.
      </Fragment>
    );
  }

  renderUnlimitedText() {
    return (
      <Fragment>
        You're on the <b>Unlimited</b> plan, which gives you as many tacks as you want, as often as you want.
      </Fragment>
    );

  }
}



// WEBPACK FOOTER //
// ./src/components/plans.jsx